import { render, staticRenderFns } from "./Book2.vue?vue&type=template&id=177e7d58&scoped=true"
import script from "./Book2.vue?vue&type=script&lang=js"
export * from "./Book2.vue?vue&type=script&lang=js"
import style0 from "./Book2.vue?vue&type=style&index=0&id=177e7d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177e7d58",
  null
  
)

export default component.exports